import React from 'react';
import PropTypes from 'prop-types';

import LikeIcon from './icons/Like';
import CloseIcon from './icons/Close';

const SwiperButtons = ({
  disabled,
  handleDiscardedProperty,
  handleLikedProperty
}) => (
  <div className="swiper-buttons">
    <button
      className="swiper-buttons__unlike"
      onClick={handleDiscardedProperty}
      type="button"
      disabled={disabled}
    >
      <CloseIcon />
    </button>
    <button
      className="swiper-buttons__like"
      onClick={handleLikedProperty}
      type="button"
      disabled={disabled}
    >
      <LikeIcon isFilled />
    </button>
  </div>
);

SwiperButtons.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleDiscardedProperty: PropTypes.func.isRequired,
  handleLikedProperty: PropTypes.func.isRequired
};

export default SwiperButtons;
